import { useQuery } from '@tanstack/react-query';
import req from 'utils/req';

async function fetchAvailableTimes({ experienceId, date }) {
  const response = (await req(
    `${URL_API_HOST}/api/v2/agenda/experience/times/${experienceId}/${date}`,
  ).get()) as Promise<Record<string, Set<string>>>;
  const result = [];

  Object.entries(response).forEach(([hostId, times]) => {
    times.forEach((time) => {
      const existingTime = result.find((entry) => entry.time === time);
      if (existingTime) {
        existingTime.locals.push(hostId);
      } else {
        result.push({ time, locals: [hostId] });
      }
    });
  });

  result.sort((a, b) => {
    const [hourA, minuteA] = a.time.split(':').map(Number);
    const [hourB, minuteB] = b.time.split(':').map(Number);

    return hourA - hourB || minuteA - minuteB;
  });

  return result;
}

function useAvailableTimes({ experienceId, date }) {
  const query = useQuery({
    queryKey: ['available-times', experienceId, date],
    queryFn: () => fetchAvailableTimes({ experienceId, date }),
    onError: (error: any) => error,
    retry: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: !!experienceId && !!date,
  });
  return {
    availableTimes: query.data ?? [],
    loading: query.isLoading,
    error: query.error,
  };
}

export default useAvailableTimes;
